import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { GetAllCustomerInfoDetailResponse } from "../../models/customer.model";
import { GetTransactionsResponse } from "../../models/wallet.model";
import { GetCustomerInfoDetail } from "../../services/customer.service";
import { GetTransactions } from "../../services/wallet.service";
import CustomerHeader from "./components/CustomerHeader";
import CustomerInfoDetailSkeleton from "./components/CustomerInfoDetailSkeleton";
import CustomerLoanDetail from "./components/CustomerLoanDetail";
import CustomerSaleDetail from "./components/CustomerSaleDetail";
import CustomerWalletDetail from "./components/CustomerWalletDetail";
import WalletTransactionsModal from "./components/WalletTransactionsModal";

const CustomerInfoDetail = () => {
  const [customerInfo, setCustomerInfo] = useState<
    GetAllCustomerInfoDetailResponse
  >();
  const [transactionList, setTransactionList] = useState<
    GetTransactionsResponse[]
  >([]);
  const [openModal, setOpenModal] = useState(false);
  const history = useHistory<{ customerId: number }>();
  const customerId =
    history?.location?.state?.customerId !== undefined
      ? history?.location?.state?.customerId
      : localStorage.getItem("CUSTOMER_ID");

  const { mutate: GetCustomerInfoDetailMutate, isLoading } = useMutation(
    GetCustomerInfoDetail,
    {
      onSuccess: (data: GetAllCustomerInfoDetailResponse) => {
        if (data) {
          setCustomerInfo(data);
        }
      },
      onError: () => {},
    }
  );
  const {
    mutate: GetTransactionsMutate,
    isLoading: transactionLoading,
  } = useMutation(GetTransactions, {
    onSuccess: (data: GetTransactionsResponse[]) => {
      if (data) {
        setTransactionList(data);
      }
    },
    onError: () => {},
  });

  // handlers
  const handleDetailLoan = (referenceKey: string) => {
    window.sessionStorage.setItem("idFind", referenceKey);
    const newWindow = window.open(
      "/#/Search/SupplierSearch1/request-find-detail",
      "_blank"
    );
    newWindow?.history.pushState(
      {
        id: referenceKey,
      },
      "",
      "/Search/SupplierSearch1/request-find-detail"
    );
  };
  const handleDetailSale = (saleKey: string) => {
    localStorage.setItem(
      "SETTLEMENT_REQUEST_DATA",
      JSON.stringify({
        saleKey,
      })
    );
    const newWindow = window.open("/#/StoreRequestDetail", "_blank");
    newWindow?.history.pushState(
      {
        settlementData: {
          saleKey,
        },
      },
      "",
      "/StoreRequestDetail"
    );
  };

  const handleDetailWallet = (id: number) => {
    setOpenModal(true);
    GetTransactionsMutate({
      customerPersonId: Number(customerId),
      walletId: id,
    });
  };

  useEffect(() => {
    GetCustomerInfoDetailMutate({ customerId: Number(customerId) });
  }, []);

  if (isLoading) {
    return <CustomerInfoDetailSkeleton />;
  }
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <CustomerHeader personInfo={customerInfo?.personInfo!} />
      {customerInfo?.loanInfo?.length! > 0 && (
        <CustomerLoanDetail
          loanInfo={customerInfo?.loanInfo!}
          handleDetail={handleDetailLoan}
        />
      )}
      {customerInfo?.saleInfo?.length! > 0 && (
        <CustomerSaleDetail
          saleInfo={customerInfo?.saleInfo!}
          handleDetail={handleDetailSale}
        />
      )}
      {customerInfo?.walletInfo?.length! > 0 && (
        <CustomerWalletDetail
          walletInfo={customerInfo?.walletInfo!}
          handleDetail={handleDetailWallet}
        />
      )}
      <WalletTransactionsModal
        transactionList={transactionList!}
        openModal={openModal}
        setOpenModal={setOpenModal}
        loading={transactionLoading}
        handleToSaleDetail={handleDetailSale}
      />
    </Box>
  );
};

export default CustomerInfoDetail;
